import { defineMessages } from 'react-intl'

export default defineMessages({
    customerId: {
        id: 'containers.ReportPage.Accounting.AccountingToBePaidTasksPage.components.ReportResults.customerId',
        defaultMessage: 'customer_uid',
    },
    customerCountry: {
        id: 'containers.ReportPage.Accounting.AccountingToBePaidTasksPage.components.ReportResults.customerCountry',
        defaultMessage: 'customer_country',
    },
    customerCountryId: {
        id: 'containers.ReportPage.Accounting.AccountingToBePaidTasksPage.components.ReportResults.customerCountryId',
        defaultMessage: 'customer_country_id',
    },
    customerPartner: {
        id: 'containers.ReportPage.Accounting.AccountingToBePaidTasksPage.components.ReportResults.customerPartner',
        defaultMessage: 'customer_partner',
    },
    customerSubmissionId: {
        id: 'containers.ReportPage.Accounting.AccountingToBePaidTasksPage.components.ReportResults.customerSubmissionId',
        defaultMessage: 'customer_submission_id',
    },
    customerAccountingId: {
        id: 'containers.ReportPage.Accounting.AccountingToBePaidTasksPage.components.ReportResults.customerAccountingId',
        defaultMessage: 'customer_accounting_id',
    },
    customerName: {
        id: 'containers.ReportPage.Accounting.AccountingToBePaidTasksPage.components.ReportResults.customerName',
        defaultMessage: 'customer_name',
    },
    orderUid: {
        id: 'containers.ReportPage.Accounting.AccountingToBePaidTasksPage.components.ReportResults.orderUid',
        defaultMessage: 'order_uid',
    },
    orderPartner: {
        id: 'containers.ReportPage.Accounting.AccountingToBePaidTasksPage.components.ReportResults.orderPartner',
        defaultMessage: 'order_partner',
    },
    orderCreated: {
        id: 'containers.ReportPage.Accounting.AccountingToBePaidTasksPage.components.ReportResults.orderCreated',
        defaultMessage: 'order_created',
    },
    taskId: {
        id: 'containers.ReportPage.Accounting.AccountingToBePaidTasksPage.components.ReportResults.taskId',
        defaultMessage: 'task_uid',
    },
    taskCreated: {
        id: 'containers.ReportPage.Accounting.AccountingToBePaidTasksPage.components.ReportResults.taskCreated',
        defaultMessage: 'task_created',
    },
    targetLanguage: {
        id: 'containers.ReportPage.Accounting.AccountingToBePaidTasksPage.components.ReportResults.targetLanguage',
        defaultMessage: 'target_language',
    },
    sourceLanguage: {
        id: 'containers.ReportPage.Accounting.AccountingToBePaidTasksPage.components.ReportResults.sourceLanguage',
        defaultMessage: 'source_language',
    },
    supplier: {
        id: 'containers.ReportPage.Accounting.AccountingToBePaidTasksPage.components.ReportResults.supplier',
        defaultMessage: 'supplier',
    },
    typeName: {
        id: 'containers.ReportPage.Accounting.AccountingToBePaidTasksPage.components.ReportResults.typeName',
        defaultMessage: 'type_name',
    },
    typeId: {
        id: 'containers.ReportPage.Accounting.AccountingToBePaidTasksPage.components.ReportResults.typeId',
        defaultMessage: 'type_id',
    },
    cost: {
        id: 'containers.ReportPage.Accounting.AccountingToBePaidTasksPage.components.ReportResults.cost',
        defaultMessage: 'cost',
    },
    costCurrency: {
        id: 'containers.ReportPage.Accounting.AccountingToBePaidTasksPage.components.ReportResults.costCurrency',
        defaultMessage: 'cost_currency',
    },
    price: {
        id: 'containers.ReportPage.Accounting.AccountingToBePaidTasksPage.components.ReportResults.price',
        defaultMessage: 'price',
    },
    priceCurrency: {
        id: 'containers.ReportPage.Accounting.AccountingToBePaidTasksPage.components.ReportResults.priceCurrency',
        defaultMessage: 'price_currency',
    },
    discountPercentage: {
        id: 'containers.ReportPage.Accounting.AccountingToBePaidTasksPage.components.ReportResults.discountPercentage',
        defaultMessage: 'discount_percentage',
    },
    netSales: {
        id: 'containers.ReportPage.Accounting.AccountingToBePaidTasksPage.components.ReportResults.netSales',
        defaultMessage: 'net_sales',
    },
    closed: {
        id: 'containers.ReportPage.Accounting.AccountingToBePaidTasksPage.components.ReportResults.closed',
        defaultMessage: 'closed',
    },
    invoiced: {
        id: 'containers.ReportPage.Accounting.AccountingToBePaidTasksPage.components.ReportResults.invoiced',
        defaultMessage: 'invoiced',
    },
    retakeId: {
        id: 'containers.ReportPage.Accounting.AccountingToBePaidTasksPage.components.ReportResults.retakeId',
        defaultMessage: 'retake_id',
    },
    retakeName: {
        id: 'containers.ReportPage.Accounting.AccountingToBePaidTasksPage.components.ReportResults.retakeName',
        defaultMessage: 'retake_name',
    },
    creditorNr: {
        id: 'containers.ReportPage.Accounting.AccountingToBePaidTasksPage.components.ReportResults.creditorNr',
        defaultMessage: 'creditor_nr',
    },
    date: {
        id: 'containers.ReportPage.Accounting.AccountingToBePaidTasksPage.components.ReportResults.date',
        defaultMessage: 'date',
    },
    markAsPaid: {
        id: 'containers.ReportPage.Accounting.AccountingToBePaidTasksPage.components.ReportResults.markAsPaid',
        defaultMessage: 'Mark as paid',
    },
    noData: {
        id: 'containers.ReportPage.Accounting.AccountingToBePaidTasksPage.components.ReportResults.noData',
        defaultMessage: 'No tasks',
    },
    missingSupplierCreditorId: {
        id: 'containers.ReportPage.Accounting.AccountingToBePaidTasksPage.components.ReportResults.missingSupplierCreditorId',
        defaultMessage: 'Missing supplier creditor id',
    }
})
